<template>
  <div class="card-body mt-2 mb-2">
    <img src="@/assets/img/brand/logo.png" class=" d-lg-none header-brand-img text-left float-left mb-4" alt="logo">
    <div class="clearfix"></div>
    <h5 class="text-left mb-2 text-capitalize">{{$t('auth.forgotPassword')}}</h5>
    <p class="mb-4 text-muted tx-13 ml-0 text-left">{{$t('auth.forgotPasswordInfo')}}</p>
    <ValidationObserver class="form-horizontal" data-select2-id="11" tag="form" ref="updatePasswordForm"
                        @submit.prevent="passwordConfirmation()">
      <div class="mb-4 main-content-label">{{$t('profile.changePassword')}}</div>
      <ValidationProvider tag="div" v-slot="{ validate, classes }" rules="required" class="form-group text-left">
        <label class="form-label" for="password">{{$t('auth.code')}}</label>
        <input
          id="password"
          v-model="formData.code"
          :class="classes"
          @input="validate"
          type="text"
          name="password"
          class="form-control"
          placeholder="code"
        />
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="form-group text-left pos-relative mb-4"
        name="Password"
        rules="required|min:6"
        vid="confirmation"
        v-slot="{ validate, errors, classes }"
      >
        <label class="form-label" for="password-confirm">{{$t('profile.strongPassword')}}</label>
        <input
          name="password"
          class="form-control"
          id="password-confirm"
          v-model="formData.password"
          type="password"
          :placeholder="$t('profile.strongPassword')"
          :class="classes"
          @input="validate"
          aria-describedby="password-confirm-live-feedback"
          size="lg"
        />
        <b-form-invalid-feedback class="pos-absolute" id="password-confirm-live-feedback">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </ValidationProvider>
      <ValidationProvider
        tag="div"
        class="form-group text-left pos-relative"
        name="Confirm Password"
        rules="required|min:6|confirmed:confirmation"
        v-slot="{ validate, errors, classes }"
      >
        <label class="form-label" for="newPassword">{{$t('profile.confirmPassword')}}</label>
        <input id="newPassword"
               :class="classes"
               @input="validate"
               type="password"
               name="confirm_password"
               class="form-control"
               v-model="formData.password_confirmation"
               :placeholder="$t('profile.confirmPassword')"
               aria-describedby="password-live-feedback"
               size="lg"
        />
        <b-form-invalid-feedback class="pos-absolute" id="password-live-feedback">
          {{ errors[0] }}
        </b-form-invalid-feedback>
      </ValidationProvider>
      <div class="form-group ">
        <button type="submit" class="btn btn-primary my-2 btn-icon-text">
          {{$t('profile.save')}}
        </button>
      </div>
    </ValidationObserver>
    <div class="card-footer border-top-0 pl-0 mt-3 text-left">
      <p>{{$t('auth.rememberedPassword')}}</p>
      <p class="mb-0">Try to
        <router-link to="/auth/sign-in">{{$t('auth.signIn')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PasswordReset',
  data () {
    return {
      formData: {}
    }
  },
  methods: {
    ...mapActions({
      checkCode: 'auth/checkCode'
    }),
    passwordConfirmation () {
      this.$refs.updatePasswordForm.validate().then(success => {
        if (success) {
          this.checkCode(this.formData).then(() => {
            this.$toasted.success('password changed successfully:').goAway(1500)
            this.$router.push('/auth/sign-in')
            this.$refs.updatePasswordForm.reset()
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.$toasted.error('You have entered wrong password!').goAway(1500)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
